export default "__VITE_ASSET__8fa926ad__"